// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__22UFk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__YfuQE","obliqueLine":"membershipbadge_obliqueLine__iUaFa"};